module.exports = __webpack_public_path__ + "c55f3f9e4b60c8cdbdbd32f10f303e14.png";